/**
 * Get Provided image bottom pixels color
 */

const precision = 2; // Percent of pixels to calculate
const fallbackColor = '#cccccc';

export const getImageBottomColor = (imgEl) => {
    let pixelData;
    const tempCanvas = document.createElement('canvas');

    tempCanvas.width = imgEl.width * (precision / 100);
    tempCanvas.height = 1;

    tempCanvas.getContext('2d').drawImage(imgEl, 0, -imgEl.height + 1, imgEl.width * (precision / 100), imgEl.height);

    try { // On cross imported image data this wouldn't work! Fallback to gray;
        pixelData = tempCanvas.getContext('2d').getImageData(0, 0, tempCanvas.width, 1).data;
    } catch (e) {
        pixelData = [];
    }

    const values = [0, 0, 0];

    if (!pixelData || !pixelData.length) {
        return fallbackColor; // Fallback color
    }

    for (let i = 0; i < pixelData.length; i += 4) {
        values[0] += pixelData[i];
        values[1] += pixelData[i + 1];
        values[2] += pixelData[i + 2];
    }

    return values.map((value) => Math.round(value / tempCanvas.width).toString(16)).reduce((result, hex) => result + `00${hex}`.slice(-2), '#');
};
